import styled from 'styled-components';
import { Container as ContainerMondrian, Radio } from 'mondrian-react';

export const Container = styled(ContainerMondrian)`
  * {
    padding: 0;
    margin: 0;
    vertical-align: baseline;
    list-style: none;
    border: 0;
  }

  width: 100%;
  max-width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;

  padding-left: 0;
  padding-right: 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  .content {
    position: relative;
    max-width: 34rem;
    padding-left: 1rem;
    padding-right: 1rem;
    flex: 1;
    display: flex;
    flex-direction: column;

    .content-subtitle {
      margin-top: 75px;
      left: 0%;
      right: -33.15%;
      top: 0%;

      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 19px;
      line-height: 40px;

      color: #e3262e;
    }

    .content-title {
      right: -33.15%;
      bottom: -173.81%;

      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 40px;
      line-height: 40px;

      color: #000;
    }

    .content-body {
      margin: 36px 0px;
      display: flex;
      flex-direction: column;
      gap: 35px;

      .img {
        float: left;
        margin-right: 10px;
      }

      p {
        vertical-align: top;
        display: inline;
        gap: 20px;
        left: 14.44%;
        right: 8.33%;
        top: 43.59%;
        bottom: 50.16%;

        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #000000;

        .bold {
          font-weight: 700;
        }
      }
      span::before {
        font-size: 2.5rem;
        color: #000;
        font-weight: normal;
      }
    }
    .background-claro {
      z-index: -1;
      position: absolute;
      height: 250px;

      right: -90px;
      top: 10px;
    }
  }

  .footer-action {
    z-index: 0;
    width: 100%;
    height: 130px;
    min-height: 130px;
    background: #ffffff;
    text-align: center;

    .progress-base {
      display: inline-block;
      text-align: center;
      width: 350px;
      max-width: 95%;
      margin-top: 20px;
    }
  }

  .mdn-Modal {
    padding-top: 15px;

    .mdn-Modal-content {
      align-self: end;
      max-width: 100%;
      width: 100%;
    }

    .mdn-Modal--sm {
      max-width: 100%;
      width: 100%;
    }

    .content-modal-term {
      height: 100%;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
      .content-term-text-modal-term {
        flex: 1;
        max-height: calc(100vh - 300px);
        overflow-y: scroll;
      }
      .mdn-Divider {
        margin-top: 20px;
      }
      .bottom-button-modal-term {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        height: 55px;
      }
    }
  }
`;
